'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import ReactTooltip from 'react-tooltip'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Badges = require('./Badges.css');

var _Badges2 = _interopRequireDefault(_Badges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Badges = (_dec = (0, _reactCssModules2.default)(_Badges2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Badges, _Component);

  function Badges(props) {
    (0, _classCallCheck3.default)(this, Badges);
    return (0, _possibleConstructorReturn3.default)(this, (Badges.__proto__ || (0, _getPrototypeOf2.default)(Badges)).call(this, props));
  }

  (0, _createClass3.default)(Badges, [{
    key: 'renderActiveBadges',
    value: function renderActiveBadges(count, labels) {
      return labels.map(function (label, idx) {
        var isActive = idx < count;
        var styleActive = isActive ? 'badge-active' : 'badge-inactive';
        var tip = isActive ? 'No ' + label + ' investments!' : 'Has ' + label + ' investments';

        return _react2.default.createElement(
          'div',
          { key: idx,
            styleName: styleActive,
            'data-multiline': true,
            'data-effect': 'solid',
            'data-tip': "<div style='max-width:150px;'>" + tip + '</div>',
            'data-for': 'badges-tooltip',
            'data-place': 'bottom',
            'data-html': true },
          _react2.default.createElement('i', { className: 'fa fa-certificate' })
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var fund = this.props.fund;
      var badgeCount = 0;
      var badgeLabelsActive = [];
      var badgeLabelsInactive = [];
      var labels = {
        'c2': 'Carbon Underground 200',
        'co': 'coal industry',
        'og': 'oil/gas industry',
        'f5': 'Macroclimate 50',
        'ut': 'fossil-fired utilities'
      };

      (0, _keys2.default)(labels).forEach(function (key, idx) {
        if (fund[key + 'count'] === '0') {
          badgeCount += 1;
          badgeLabelsActive.push(labels[key]);
        } else {
          badgeLabelsInactive.push(labels[key]);
        }
      });

      var badgeLabels = badgeLabelsActive.concat(badgeLabelsInactive);

      var badgeStyleName = 'badge-wrap';
      if (this.props.small) {
        badgeStyleName += '-small';
      }

      return _react2.default.createElement(
        'div',
        { styleName: badgeStyleName },
        this.renderActiveBadges(badgeCount, badgeLabels)
      );
    }
  }]);
  return Badges;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired,
  small: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Badges;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Badges/Badges.js
// module id = 1367
// module chunks = 0